import PublicNotice from "@/modules/portfolio/ui/public-notice";
import type { PublicNoticeView } from "@buildpy/core/views/g4b/notice";

// 소개 링크 — 로그인 없음 · 이동(간편접수)은 view 가 redirect 로 돌려주고, 여기는 한도에 걸린 안내만 그린다.
const Page = ({ data }: { data: PublicNoticeView }) => <PublicNotice text={data.text} />;

export default Page;
